// extracted by mini-css-extract-plugin
export default {"imageBlock":"styles_imageBlock__R0VSK","pwaMode":"styles_pwaMode__ShPLM","emptyImage":"styles_emptyImage__Z3xpJ"};